export default __webpack_public_path__ + "static/media/scg-icon.c990aaed.svg";